
import React, { useEffect, useState, useRef } from 'react'
import style from './index.module.scss'
import { DatePicker, Drawer, Form, Button, Input, InputNumber, Collapse, Tooltip, Divider, message, Select } from 'antd';
import useStore from '../../store/useStore'
import moment from "moment";
import * as apis from '../../api/networkDisk'
import { StorageModule } from '../../modules/storage'

import { deepCopy, getImgUrlById } from '../../util'
import user_default from '../../static/image/user_default.png'
import {
    PlusCircleOutlined, CloseCircleOutlined, DeleteOutlined, CheckOutlined
} from '@ant-design/icons';
import Users from './users'

interface Props {
    visible?: boolean;
    labelData?: any;
    subjectData?: any;
    title?: any;
    startDate?: any;
    onClose: () => void;
    className?: any,
    type?: any
}

interface State {
}
const { Panel } = Collapse;
const LableDrawer = (props: Props) => {

    const [ikey, setIkey] = useState<string>('');
    const scroll = useRef<any>()
    const { store, dispatch } = useStore();
    const [form] = Form.useForm();
    const [form1] = Form.useForm();
    const [form2] = Form.useForm();
    const [form3] = Form.useForm();
    const [data, setData] = useState<any>([]);
    const [isDeletExecutor, setIsDeletExecutor] = useState<boolean>(false);
    const [usersVisible, setUsersVisible] = useState<boolean>(false);
    const [executorInfo, setExecutorInfo] = useState<any>({});
    const [titleClass, setTitleClass] = useState<any>('clamp1');
    const [taskTagList, setTaskTagList] = useState<any>([]);
    const [mimeType, setMimeType] = useState<any>("");
    const [labelTagList, setLabelTagList] = useState<any>([]);
    const [metaLabelTag, setMetaLabelTag] = useState<any>([]);
    const [markValue, setMarkValue] = useState<any>({});


    const taskTab = [{
        class: 'item1',
        name: '任务计划',
        label1: '计划完成时间',
        label2: '预计工时h',

    },
    {
        class: 'item2',
        name: '开始执行',
        label1: '预计完成时间',
        label2: '预计工时h'
    },
    {
        class: 'item3',
        name: '任务完成',
        label1: '实际完成时间',
        label2: '实际工时h'
    }, {
        class: 'item4',
        name: '版本计划',
        label1: '版本号',
        label2: ''
    }]
    let formArr: any = [form, form1, form2, form3]

    useEffect(() => {
        let _task: any = []
        let _lable: any = []
        console.log('store.tagMeta', store.tagMeta, taskTab)
        store.tagMeta.map((i: any) => {
            if (i.type === 'attachment') {
                _task.push({ ...i, ...taskTab.filter((j: any) => i.name === j.name)[0], isHover: false, isSelect: false })
            }
            if (i.notation == "LabelTag") {
                setMetaLabelTag(i.catalogues)
            }
        })
        setTaskTagList(_task)
        // setTaskTagList(store.tagMeta.filter((i: any) => i.type === 'attachment'))
    }, [store.tagMeta])

    useEffect(() => {
        console.log('store.memoInfo', store.memoInfo)
        if (store.memoInfo) {
            initForm()
            initMetaForm()
        }
    }, [store.memoInfo, store.showDrawLabel])
    const initMetaForm = () => {
        if (store.memoInfo.hasOwnProperty('data') && store.memoInfo?.data?.tagMetas) {
            let _labelTagList: any = deepCopy(store.memoInfo?.data?.tagMetas.filter((i: any) => i.type === "classifier"))
            console.log(_labelTagList)
            _labelTagList.map((item: any, index: any) => {
                item.isSelect = false
                item.isHover = false
                item = { ...item, ...item.instance }
                _labelTagList[index] = { ...item, ...item.instance }
            })
            setLabelTagList(_labelTagList)
        }
    }
    const initForm = () => {
        console.log('store.memoInfo?.data?.tagMetas', store.memoInfo)
        if (store.memoInfo.hasOwnProperty('data')) {
            store.tagMeta.map((i: any) => {
                if (i.mimeType == store.memoInfo?.data?.mimeType) {
                    // setMimeType(`${i.name}-${i.mimeType}`)
                    setMimeType(`${i.name}`)
                }
            })

            //设置表单初始值，如果任务被贴标签了，则显示该标签值
            reset()
            // for (let i = 0; i < formArr.length; i++) {
            //     formArr[i].setFieldsValue({
            //         manHour: null,
            //         finishTime: null,
            //         executorId: null,
            //         release: null
            //     });
            // }
            if (store.memoInfo?.data?.tagMetas) {
                // let _tagMetas: any = deepCopy(store.memoInfo?.data?.tagMetas.filter((i: any) => i.type === "attachment"))
                let _tagMetas: any = deepCopy(store.memoInfo?.data?.tagMetas)
                _tagMetas.map((item: any, index: any) => {
                    // if (memo.type !== "attachment") return
                    item = { ...item, ...item.instance }
                    _tagMetas[index] = { ...item, ...item.instance }

                    console.log(item)
                    // let item: any = memo.instance
                    // item = { ...memo.instance, instance: memo.instance }
                    let idx: any = taskTagList.findIndex((i: any) => i.name === item.name)
                    if (idx > -1) {
                        formArr[idx].setFieldsValue({
                            manHour: item?.manHour || null,
                            finishTime: item ? moment(item.finishTime) : null,
                            executorId: item?.executorId || null,
                            release: item?.release
                        });
                        console.log(item)
                        if (item.executorUser && item.name == '任务计划') {
                            setExecutorInfo(item.executorUser)
                        } else {
                            setExecutorInfo({})
                        }
                        console.log(formArr[idx].getFieldsValue())
                    }

                })
                console.log(_tagMetas)
                setData(_tagMetas)

            }
        }
    }
    useEffect(() => {
        // setIsDeletExecutor(true)
        console.log(executorInfo.id)
        if (executorInfo.id) {
            setIsDeletExecutor(false)
        }
    }, [executorInfo])
    useEffect(() => {
        if (store.showDrawLabel) {
            console.log('labelDrawer--show')
            dispatch({
                type: 'GET_TAGMETA',
            });
            // document.body.addEventListener('click', function (e) {

            //     var cDom: any = document.querySelector(".init");

            //     var tDom = e.target;

            //     if (cDom == tDom || cDom.contains(tDom)) {
            //         console.log('点击这里', cDom, tDom)
            //     } else {
            //         console.log('点击其他', cDom, tDom)

            //         // self.setState({ isShow: 'hide' });
            //         labelTxtReset()
            //     }

            // }, false);

        }
    }, [store.showDrawLabel])
    const labelTxtReset = (idx?: any) => {
        let list: any = []
        initForm()
        taskTagList.map((i: any, index: any) => {
            // if (idx === index) { } else {
            //     // reset()
            //     formArr[idx].resetFields()
            // }
            list.push({ ...i, isSelect: (idx === index) ? true : false })
        })
        setTaskTagList(list)
        // reset()
    }
    const metaReset = (idx?: any) => {
        let list: any = []
        initMetaForm()
        labelTagList.map((i: any, index: any) => {
            // if (idx === index) { } else {
            //     // reset()
            //     formArr[idx].resetFields()
            // }
            list.push({ ...i, isSelect: (idx === index) ? true : false })
        })
        setLabelTagList(list)
        // reset()
    }
    const reset = () => {
        form.resetFields()
        form1.resetFields()
        form2.resetFields()
        form3.resetFields()
    }
    /**
        * 删除任务计划
        * @returns 
        */
    const delMemoNotation = async (params: any, idx: any) => {
        console.log(params, idx, data)
        try {
            console.log(data.findIndex((i: any) => i.name === params.name), idx)
            if (data.findIndex((i: any) => i.name === params.name) > -1) {
                let res: any = await apis.delMemoNotation(params.id, store.tagMeta.filter((i: any) => i.name === params.name)[0]?.notation,)
                console.log(res)
                if (res.ok) {
                    dispatch({
                        type: 'SET_CALENDARLABLE',
                        data: { content: store.memoInfo?.data?.content, }
                    });
                    let _tagMetas: any = deepCopy(data)
                    console.log(_tagMetas)
                    _tagMetas.map((i: any, index: any) => {
                        if (i.name == params.name) {
                            _tagMetas[index] = {}
                        }
                        if (i.name == '任务计划') {
                            setExecutorInfo('')
                        }
                    })
                    // _tagMetas[idx]={}
                    // _tagMetas.splice(idx, 1)
                    dispatch({
                        type: 'SET_MEMOINFO',
                        data: { ...store.memoInfo, data: { ...store.memoInfo.data, tagMetas: _tagMetas } }
                    });
                }
            } else {
                message.error(`该任务没有添加${params.name}标签！`)
            }
        } catch (e) { }
    }
    const editMemoLabelTag = async (item: any, metaId: any) => {
        // let res: any = await apis.putLabelTag(store.memoInfo.data.id, { id: metaId, markValue: "sssooo" })
        // let res: any = await apis.putLabelTag(metaId, { markValue: "sssooo" })
        let res: any = await apis.putMemoNotation(store.memoInfo.data.id, "LabelTag", { id: metaId })

    }
    /**
        * 新建/修改任务计划
        * @returns 
        */
    const addTask = async (params: any, form: any) => {
        try {
            let _userInfo: any = StorageModule.getUser().user
            let _params: any = {
                memoId: store.memoInfo.data.id,
                name: params.name,
            }
            if (params.name !== '任务计划') {
                _params.executorId = (form.getFieldsValue().executorId) ? form.getFieldsValue().executorId : _userInfo?.id

            } else {
                _params.executorId = form.getFieldsValue().executorId || executorInfo.id
            }
            if (params.name !== '版本计划') {
                _params.finishTime = moment(form.getFieldsValue().finishTime).format('YYYY-MM-DDT23:59:59')
                _params.manHour = form.getFieldsValue().manHour
            }
            console.log(params, _params, _params.executorId)
            // return
            if (!form.getFieldsValue().hasOwnProperty('release')) {
                let res: any = await apis.putMemoNotation(store.memoInfo.data.id, taskTagList.filter((i: any) => i.name === params.name)[0].notation, _params)

                if (res.ok) {
                    labelTxtReset()
                    //如果任务计划更改执行人，则更改成功后关闭弹窗
                    if (props.type && props.type === 'memo') { } else {
                        if (params.executorId !== _params.executorId && params.name == '任务计划') {
                            props.onClose()
                        }
                        if (!props.startDate?.some((i: any) => i === moment(_params.finishTime).format('YYYY-MM-DD'))) {
                            props.onClose()
                        }
                    }
                    dispatch({
                        type: 'SET_CALENDARLABLE',
                        data: { ...res.data, content: store.memoInfo?.data?.content, }
                    });
                    let _tagMetas: any = deepCopy(store.memoInfo?.data?.tagMetas)
                    let isAdd: any = _tagMetas.findIndex((i: any) => (i.name === params.name))
                    if (isAdd > -1) {
                        console.log('修改任务标签', res.data.instance, _tagMetas, isAdd)
                        _tagMetas[isAdd] = { ...res.data, ...res.data.instance, }
                    } else {
                        console.log('新增任务标签')
                        _tagMetas.push({ ...res.data, ...res.data.instance, })
                    }
                    console.log(_tagMetas)
                    dispatch({
                        type: 'SET_MEMOINFO',
                        data: { ...store.memoInfo, data: { ...store.memoInfo.data, tagMetas: _tagMetas } }
                    });

                }
            } else {
                let res: any = await apis.putMemoRelease(store.memoInfo.data.id, {
                    memoId: store.memoInfo.data.id,
                    release: form.getFieldsValue().release
                })
                if (res.ok) {
                    dispatch({
                        type: 'SET_CALENDARLABLE',
                        data: { ...res.data, content: store.memoInfo?.data?.content, name: '版本计划' }
                    });
                }

            }

        } catch (e) {
            console.log(e)

        }
    }
    const render = (
        <>
            <>
                {store.showDrawLabel && <div className='CLOSESHOWALL'>
                </div>}</>
            <>{store.showDrawLabel && <div className={`${style.draw} chatinfopop customDraw`}>

                <>
                    <div data-flex='main:justify cross:top' style={{ width: '100%' }} className={style.drawerTitle}>所属主题<CloseCircleOutlined onClick={() => { props.onClose() }} /></div>
                    <div data-flex='main:left cross:center flex-wrap'>
                        {store.memoInfo?.data?.topicIds?.map((i: any, index: any) => (
                            <>
                                <Button key={index} onClick={() => {
                                    // const { x = 0, y = 0 } = (window as any).graphItem.getCellById(store.chatId).store.data.position || {}
                                    // const width = (window.innerWidth - 480) / 2;
                                    // const height = (window.innerHeight - 100) / 2;
                                    // (window as any).graphItem.translate(width - x - 60, height - y - 60);
                                    // console.log(x, y)

                                    //当前主题是便签所在主题则不跳转
                                    let isGo
                                    if (store.subjectInfo.subjectId == i) {
                                        isGo = (window.location.hash.indexOf('memo') > -1) ? false : true
                                    } else {
                                        isGo = true
                                    }
                                    if (isGo) {

                                        dispatch({
                                            type: 'SET_PING_MEMO',
                                            data: store.memoInfo
                                        });
                                        dispatch({
                                            type: 'SET_SUBJECTINFO',
                                            data: { subjectCatalogue: [], subjectId: i, data: store.subjectInfo.initData }
                                        });
                                        window.location.hash = '#/memo'
                                    }

                                }} className={`${style.drawerTag}`}>
                                    {store.memoInfo.data.topicNames && store.memoInfo.data.topicNames.length > 0 && <>{
                                        store.memoInfo.data.topicNames[index].length > 6 ? <Tooltip title={store.memoInfo.data.topicNames[index]} placement="topLeft"  >
                                            {store.memoInfo.data.topicNames[index].slice(0, 6) + '…'}
                                        </Tooltip> : <>{store.memoInfo.data.topicNames[index]}</>

                                    }</>}</Button>
                            </>
                        ))}
                    </div>
                    {mimeType == '类别标注' ? <div className={style.drawerTitle}><Divider orientation="left">分类标签</Divider>
                        {labelTagList?.map((item: any, idx: any) => {
                            let _item: any = {}
                            console.log(data)
                            if (data && data.findIndex((i: any) => i.name === item.name) > -1) {
                                _item = data.find((i: any) => i.name === item.name)

                            } else {
                                _item = item
                            }
                            return (
                                <>
                                    <div data-flex='main:left cross:center' className={`${style.panel} init`}>
                                        <>{console.log(item, metaLabelTag)}</>
                                        <div data-flex='main:justify cross:center' onClick={() => {
                                            if (!item.isSelect) {
                                                metaReset(idx)
                                            }
                                        }}>
                                            {!item.isSelect ? <div>{item.instance.catalogue}-{item.instance.markValue}</div>
                                                : <div>{item.instance.catalogue}- <Select
                                                    defaultValue={item.instance.markValue}
                                                    style={{ width: 120 }}
                                                    onChange={(e) => {
                                                        console.log(e)
                                                        editMemoLabelTag(item, e)
                                                    }}
                                                    fieldNames={
                                                        { label: 'markValue', value: 'id' }
                                                    }
                                                    options={metaLabelTag[item.instance.catalogue]} />
                                                </div>
                                            }
                                            <div className='ml-10'>
                                                <DeleteOutlined onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    delMemoNotation(_item, idx)
                                                }} className={`${style.delete} icon_hover mr-10`} />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )
                        })}

                    </div>
                        :
                        <div className={style.drawerTitle}><Divider orientation="left">格式标签</Divider>
                            <div data-flex='main:justify cross:center' className='init'>
                                <div className={`${style.button}`} style={{ color: '#606264' }}>当前内容格式:{mimeType}</div>
                            </div>
                        </div>
                    }
                    <div className={style.drawerTitle}><Divider orientation="left">业务标签</Divider></div>
                    {/* <div className={`${style.drawerContent} ${store.memoInfo?.data?.content.length > 6 ? titleClass : ''}`}
                        onMouseEnter={() => {
                            setTitleClass('')
                        }}
                        onMouseLeave={() => {
                            setTitleClass('clamp1')
                        }}
                    > {store.memoInfo?.data?.content}</div> */}
                    {/* <Collapse accordion> */}
                    <div className=''>{taskTagList.map((item: any, idx: any) => {
                        let _item: any = {}
                        console.log(data)
                        if (data && data.findIndex((i: any) => i.name === item.name) > -1) {
                            _item = data.find((i: any) => i.name === item.name)

                        } else {
                            _item = item
                        }
                        // console.log(_item)
                        return (
                            // <Panel header={<div className={`${item.class} ${style.button}`} >{_item.name}</div>} key={idx}>
                            <div className={`${style.panel} `} onClick={(e) => {
                                if (!item.isSelect) {
                                    labelTxtReset(idx)
                                }
                                // item.isSelect = true
                                // let list: any = []
                                // taskTagList.map((i: any, index: any) => {
                                //     list.push({ ...i, isSelect: (idx === index) ? true : false })
                                // })
                                // setTaskTagList(list)
                            }}>
                                {JSON.stringify(formArr[idx].getFieldValue()) != '{}' && <><div data-flex='main:justify cross:center' className='init'>
                                    <div className={`${item.class} ${style.item} noHover ${style.button}`}>{_item.name}</div>
                                    {item.isSelect ? <><CheckOutlined className={`  icon_hover mr-10`} onClick={() => {
                                        formArr[idx].validateFields().catch((e: any) => {
                                            console.log('err', e.errorFields)
                                            if (e.errorFields.length == 0) {
                                                addTask(_item, formArr[idx])
                                            }
                                        });

                                        console.log(formArr[idx].validateFields());
                                        // addTask(_item, formArr[idx])
                                    }} /></> :
                                        <DeleteOutlined onClick={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            delMemoNotation(_item, idx)
                                        }} className={`${style.delete} icon_hover mr-10`} />}
                                </div>
                                    {!item.isSelect ?
                                        <div className='ant-row ant-form-item-row'>
                                            {item.name === '任务计划' && <><div className="ant-col ant-col-8 ant-form-item-label">
                                                <label>执行人</label>
                                            </div>
                                                <div className="ant-col ant-col-16 ant-form-item-control-input"> {executorInfo?.id &&
                                                    <>
                                                        <img alt="" style={{ width: '30px', height: '30px' }}
                                                            src={(executorInfo?.avatar) ? getImgUrlById(executorInfo?.avatar) : user_default} onError={(e: any) => { e.target.onerror = null; e.target.src = user_default }} />
                                                        <span className={'ml-10 '}>{executorInfo?.username}</span></>
                                                }</div>
                                            </>}

                                            <div className="ant-col ant-col-8 ant-form-item-label">
                                                <label>{taskTagList.filter((i: any) => i.name === _item.name)[0].label1}</label>
                                            </div>
                                            <div className="ant-col ant-col-16 ant-form-item-control-input">{(_item.finishTime) ? moment(_item.finishTime).format("YYYY-MM-DD") : ''}</div>
                                            <div className="ant-col ant-col-8 ant-form-item-label">
                                                <label>{taskTagList.filter((i: any) => i.name === _item.name)[0].label2}</label>
                                            </div>
                                            <div className="ant-col ant-col-16 ant-form-item-control-input">{_item.manHour}</div>
                                        </div> :
                                        <Form
                                            labelCol={{ span: 8 }}
                                            wrapperCol={{ span: 16 }}
                                            onFinish={() => {
                                                addTask(_item, formArr[idx])
                                            }}
                                            // initialValues={{ manHour: _item?.manHour, finishTime: moment(_item?.finishTime) }}
                                            onFinishFailed={() => {
                                            }}
                                            autoComplete="off"
                                            form={formArr[idx]}
                                        >
                                            {_item.name === '任务计划' && <>
                                                <Form.Item
                                                    label={_item.name === '任务计划' ? '执行人' : ''}
                                                    name="executorId"
                                                    style={{ height: _item.name !== '任务计划' ? '0px' : '' }}
                                                >
                                                    {
                                                        executorInfo?.id && !isDeletExecutor ? <>
                                                            <img alt="" onClick={(e) => {
                                                                e.stopPropagation();
                                                                e.preventDefault();
                                                                setUsersVisible(true)
                                                            }} style={{ width: '30px', height: '30px' }}

                                                                src={(executorInfo?.avatar) ? getImgUrlById(executorInfo?.avatar) : user_default} onError={(e: any) => { e.target.onerror = null; e.target.src = user_default }} />
                                                            <span className={'ml-10 '}>{executorInfo?.username}</span>
                                                            <CloseCircleOutlined className={'ml-10 mt-10 icon_hover'} onClick={() => {
                                                                setIsDeletExecutor(true)
                                                                formArr[idx].setFieldsValue({
                                                                    executorId: null
                                                                });
                                                                setExecutorInfo({})
                                                            }} />
                                                        </> : <> <PlusCircleOutlined onClick={(e) => {
                                                            e.stopPropagation();
                                                            e.preventDefault();
                                                            setUsersVisible(true)
                                                        }} /></>
                                                    }
                                                </Form.Item>
                                            </>}
                                            {_item.name !== '版本计划' ? <>
                                                <Form.Item
                                                    label={taskTagList.filter((i: any) => i.name === _item.name)[0].label1}
                                                    name="finishTime"
                                                    rules={[{ required: true, message: `请输入${item.label1}!` }]}
                                                >
                                                    <DatePicker format="YYYY-MM-DD" />

                                                </Form.Item>
                                                <Form.Item
                                                    label={taskTagList.filter((i: any) => i.name === _item.name)[0].label2}
                                                    name="manHour"
                                                    rules={[{ required: true, message: `请输入${item.label2}!` }
                                                        , {
                                                        validator: (rule, val, callback) => {
                                                            if (!val) {
                                                                callback();
                                                            }
                                                            let reg = new RegExp(/^[0-9]\d*$/, "g")
                                                            if (!reg.test(val)) {
                                                                callback('请输入正整数！');
                                                            } else if (val < 1) {
                                                                // callback('此数值大于等于1')
                                                            } else if (val > 10) {
                                                                // callback('此数值小于等于10')
                                                            }
                                                            callback();

                                                        }
                                                    }]}
                                                >
                                                    <InputNumber />
                                                </Form.Item>
                                            </> :
                                                <Form.Item
                                                    label='版本号'
                                                    name="release"
                                                    rules={[{ required: true, message: '请输入版本号!' }]}
                                                >
                                                    <Input value={_item?.release} />
                                                </Form.Item>
                                            }
                                            {/* <Form.Item wrapperCol={{ offset: 8, span: 12 }}>
                                            <div data-flex='main:left' >
                                                <Button className='btn_dark btn' htmlType="submit">确认</Button>
                                            </div>
                                        </Form.Item> */}
                                        </Form>}</>}
                            </div>
                            // </Panel>
                        )

                    })}</div>

                    {/* </Collapse> */}
                </>

                <Users title={'选择执行人'} visible={usersVisible} onList={[]} onRefresh={(e, row) => {
                    setExecutorInfo(row); setUsersVisible(false)
                    setIsDeletExecutor(false)
                }} onClose={() => { setUsersVisible(false); }} />

            </div>}</>
        </>
    )

    return store.showDrawLabel ? render : null
}

export default LableDrawer

